// Buffer polyfill for browser environment
import { Buffer } from "buffer";

// Make Buffer available globally
window.Buffer = Buffer;
globalThis.Buffer = Buffer;

export { Buffer };
